import { LitElement, html } from '@hh/global.js'

export class AccountForms extends LitElement {
  static properties = {}

  connectedCallback() {
    super.connectedCallback()
    this.handleTabSwitch()
    this.handleForgotPasswordTitle()
    this.handleSuccessRecover()
  }

  handleTabSwitch() {
    const tabButtons = this.querySelectorAll('.js-tab')


    const handleTabButtonClick = (e) => {
      const selectedPanel = e.target.getAttribute('aria-controls')
      this.hideTitle()
      this.resetTitles()

      const activeTitle = this.querySelector(
        `[data-controls-from=${selectedPanel}]`
      )

      activeTitle.classList.add('active')
    }

    tabButtons.forEach((item) => {
      item.addEventListener('click', handleTabButtonClick)
    })
  }

  handleForgotPasswordTitle() {
    const forgotPasswordTitle = this.querySelector('.js-desktop-title-forgot-password')
    const forgotPasswordBtn = this.querySelector('.js-forgot-password-btn')
    const cancelForgotPasswordBtn = this.querySelector('.js-cancel-forgot-password-btn')
    const recoverSuccessEl = this.querySelector('#recover-success')

    if (window.location.hash === '#recover' || !!recoverSuccessEl) {
      this.hideTitle()
      forgotPasswordTitle?.classList.add('active')
    }

    forgotPasswordBtn?.addEventListener('click', () => {
      this.hideTitle()
      forgotPasswordTitle.classList.add('active')
    })

    cancelForgotPasswordBtn?.addEventListener('click', () => {
      this.resetTitles()

      const loginTitle = this.querySelector(
        `[data-controls-from="login-panel"]`
      )

      loginTitle.classList.add('active')
    })
  }

  hideTitle() {
    const desktopTitle = this.querySelectorAll('[data-controls-from]')
    desktopTitle.forEach((title) => {
      title.classList.remove('active')
    })
  }

  handleSuccessRecover() {
    const recoverSuccessEl = this.querySelector('#recover-success')
    const forgotPasswordTitle = this.querySelector('.js-desktop-title-forgot-password')
    const tabListEl = this.querySelector('.js-tablist')

    if (!recoverSuccessEl) return

    this.hideTitle()
    forgotPasswordTitle.classList.add('active')
    tabListEl.setAttribute('hidden', '')
  }

  resetTitles() {
    const forgotPasswordTitle = this.querySelector('.js-desktop-title-forgot-password')

    forgotPasswordTitle.classList.remove('active')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('account-forms', AccountForms)
